import styled from 'styled-components'

export const CommonStickyNavOuter = styled.div<{}>`
  ${({ theme }) => {
    return `
      padding-top: 64px;
      background-color: ${theme.webMktNewPalette.background.light.default};
      position: relative;

      .NavList{
        display: flex;
        align-items: flex-start;
        justify-content: center;        

        li{
          &:last-child{
            ${theme.breakpoints.down('xs')}{
              border-top: 2px solid ${theme.webMktNewPalette.deepBlue[10]};
            }            
          }
        }

        .item{
          padding: 64px 8px;
          min-width: 200px;
          max-width: 200px;
          font-size: 20px;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: -1px;
          cursor: pointer;
          margin-right: 24px;
          color: ${theme.webMktNewPalette.deepBlue[45]};
          display: flex;
          flex: 1 1 0%;
          justify-content: center;
          text-align: center;
          transition: all 0.3s;
          position: relative;
          ${theme.breakpoints.down('lg')}{
            margin-right: 12px;
            min-width: auto;
          }
          ${theme.breakpoints.down('md')}{
            font-size: 16px;                       
          }
        
          ${theme.breakpoints.down('sm')}{
            min-width: auto;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: normal;
            margin-right: 2px;
          }

          .tagsnchor{
            display: block;
          }
          &:before{
            content: '';
            position: absolute;
            width: 100%;
            background-color: ${theme.webMktNewPalette.deepBlue[10]};
            height: 2px;
            top: 2px;
            left:0;
            transition: background-color 0.3s;
          }
          &:last-child {
            margin-right: 0px;
          }
          &:hover,
          &.active {
            color: ${theme.webMktNewPalette.black};
            background: linear-gradient(180deg, #E4F0F5 0%, #ffffff 100%);
            
            &:before{
              background-color: ${theme.webMktNewPalette.black};
            }
          }
        }

        .StickyNavCtaDropMenu{
          display: none;
          

          .CTA{
            color: ${theme.webMktNewPalette.action.light.brand};
            font-size: 18px;
            display: flex;
            justify-content: flex-end;
            ${theme.breakpoints.down('md')}{
              font-size: 16px;
            }
            ${theme.breakpoints.down('sm')}{
              font-size: 14px;
              font-weight: 400;
            }
            ${theme.breakpoints.down('xs')}{
              font-size: 18px;
              font-weight: 600;
              width: 100%;
              justify-content: space-between;
            }
            &:hover{
              span{
                border-bottom: none;
                width: auto;
              }
            }

            .CTA__Arrow-Container{
              color: ${theme.webMktNewPalette.black}
            }
          }
        }

        ${theme.breakpoints.down('xs')}{
          flex-direction: column;
          padding: 0 16px;
          height: auto;
          transition: height 0.3s;
          justify-content: flex-start;

          .item{
            max-width: 100%;
            width: calc(100% - 16px);
            padding: 24px 8px 16px;
            justify-content: flex-start;
            flex: none;
            font-size: 18px;
            font-weight: 600;
          }
        }
      }

      .NavListDropMenu{
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: normal;
        cursor: pointer;
        margin-right: 0;
        color: ${theme.webMktNewPalette.black};
        display: flex;
        flex: 1 1 0%;
        max-width: 100%;
        width: calc(100% - 48px);
        padding: 24px 8px 20px;
        -webkit-box-pack: start;
        justify-content: space-between;
        position: absolute;
        opacity: 0;
        transition: opacity 0.3s;
        z-index: 1;
        background-color: ${theme.webMktNewPalette.white};
        margin: 0 16px;
        display: none;
        &:before{
          content: '';
          position: absolute;
          width: 100%;
          background-color: ${theme.webMktNewPalette.black};
          height: 2px;
          top: 2px;
          left: 0px;
          transition: background-color 0.3s;
        }
      }
      &.sticky {
        position: sticky;
        top: -64px;
        z-index: 999;
        transition: top 0.2s linear;
        max-width: 1920px;
        width: 100%;
        margin: 0 auto;

        .NavList{
          ${theme.breakpoints.down('xs')}{
            height: 0;
            overflow: hidden;
            position: absolute;
            width: calc(100% - 32px);
            background-color: ${theme.webMktNewPalette.white};
            z-index: 0;
            top: 70px;
          } 
          
          &.toggle {
            ${theme.breakpoints.down('xs')}{
              height: auto;
              padding-bottom: 20px;
            }
          }

          .item{
            padding: 32px 8px;
            ${theme.breakpoints.down('xs')}{
              padding: 24px 8px;
            }
          }
          .StickyNavCtaDropMenu{
            display: flex;
            padding: 30px 8px 14px;
            min-width: 180px;
            max-width: 180px;
            flex: 1 1 0%;
            text-align: center;
            position: relative;
            top: 2px;            
            ${theme.breakpoints.down('xs')}{
              padding: 16px 8px;
              width: calc(100% - 16px);
              display: flex;              
              justify-content: space-between;    
              max-width: 100%;          
            }
          }
        }
        
        .NavListDropMenu {
          ${theme.breakpoints.down('xs')}{
            opacity: 1;
            top: 0;
            display: flex;
          }
        }

        ${theme.breakpoints.down('xs')}{
          top: 0;
        }
      }

      ${theme.breakpoints.down('sm')}{
        padding-bottom: 52px;
      }
      ${theme.breakpoints.down('xs')}{
        padding-top: 0px;
        padding-bottom: 0px;
      }
      
    `
  }}
`
